import { createSelector } from 'reselect'

import selectGitHubNodes from './selectGitHubNodes'

export default createSelector(selectGitHubNodes, nodes =>
  nodes.filter(({ __typename }) => __typename === 'Repository')
)
